/* eslint-disable */
import SearchPageHotelView from "@/js/desktop/View/SearchPageHotel";
import subscribeBannerTemplate from '../templates/subscribeBannerTemplate.html'
import ecommerceService from "@/js/common/Domain/Service/ecommerce";
import getTourPropertyForHotTourClick from "@/js/common/components/hot-tours/services/getTourPropertyForHotTourClick";
import DataLayerAnalytics from "@/js/common/Domain/Service/DataLayerAnalytics";
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';
import getHrefToRedirectToTourPage from '@/js/common/Service/getHrefToRedirectToTourPage';

var searchPageHotelForExtend = SearchPageHotelView;

let SearchPageHotelHotView = searchPageHotelForExtend.extend({
	subscribeBannerTemplate,
	events: _.extend({}, searchPageHotelForExtend.prototype.events, {
		"submit .js-ht-subs": "submitHotToursSubs"
	}),
	updateSubscribes: function () {
		var $tourhunterBlock;
		if (this.viewModel.get('subscribeBanner')) {
			$tourhunterBlock = $('.hot-tour-subs', this.$el);
			setTimeout(function () {
				$tourhunterBlock.slideUp();
			}, 7000);
		}
	},
	submitHotToursSubs: function (e) {
		e.preventDefault();
		e.stopPropagation();
		var $form = $(e.target),
			scope = this,
			validateRules = {
				errorElement: 'div',
				errorClass: 'error',
				rules: {
					email: {
						required: true,
						email: true
					}
				},
				messages: {
					email: {
						required: "Обязательное поле",
						email: "Пожалуйста, введите действительный адрес электронной почты. Например johndoe@domain.com"
					}
				}
			},
			validator;

		validator = $form.validate(validateRules);
		if ($form.valid() && !$form.hasClass('subscribeInProgress')) {
			$form.addClass('subscribeInProgress');
			$.ajax({
				url: '/subscriber/hot-tours',
				data: $form.serialize(),
				dataType: "json",
				type: "POST"
			})
				.done(function (response) {
					if (response.success == true) {
						$form.hide().next().show();
						scope.collectionView.model.set('subscribe', 1);
					} else {
						validator.showErrors({
							email: validateRules.messages.email.email
						})
					}
					$form.removeClass('subscribeInProgress');
				})
				.fail(function () {
					$form.removeClass('subscribeInProgress');
				});
		}
	},
	hrefUrl: function (event) {
		const tourProducts = this.model.get('tourProducts');
		const id = this.model.get('id');
		const hrefToRedirectToTourPage = getHrefToRedirectToTourPage(tourProducts, id);
		const target = ($('.oneColumn:visible').length) ? '_self' : '_blank';
		$(event.currentTarget).attr('href', hrefToRedirectToTourPage);
		$(event.currentTarget).attr('target', target);
	},
	mindBoxTrackingHotelClick() {
        mindBoxService.trackViewSerpClick('serp_hot', {
            searhPageModel: this.model,
            collectionViewModel: this.collectionView.model,
        });
    },
	dataLayerEvents() {
		let tourProducts = this.model.get('tourProducts');
		let identity = (tourProducts && tourProducts.at) ? tourProducts.at(0).get('id') : null;
		let dataLayerAnalytics = new DataLayerAnalytics();

		let value = {
			prop1: dataLayerAnalytics.createRangeEvent(getTourPropertyForHotTourClick(this.model)),
			prop2: [{type: 'identity', id: identity}],
			prop3: [{type: 'position', value: this.viewModel.get('hotelIndex') + 1}]
		};

		dataLayerAnalytics.generateEvent('hottourClick', value);
	},
	offerClick: function () {
		ecommerceService.productClick({
			product: this.model,
			category: 'tour',
			pageType: 'serpHotTour',
			collection: this.collectionView.collection,
			departureCityName: this.collectionView.model.get('searchData').get('departureCity').get('name')
		});
	}
});
export default SearchPageHotelHotView